import { SERVER_URL, AUTH_JWT } from "../constants/appConstants";

const AuthService = {
  authenticateAsync: async (user) => {
    try {
      const response = await fetch(`${SERVER_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // ✅ 必须添加
        },
        body: JSON.stringify(user),
      });

      if (!response.ok) {
        throw new Error("Login failed");
      }

      const jwtToken = response.headers.get("Authorization");

      if (jwtToken !== null) {
        sessionStorage.setItem(AUTH_JWT, jwtToken);
      }

      return jwtToken;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  geJwt: () => sessionStorage.getItem(AUTH_JWT),

  unauthenticate: () => sessionStorage.removeItem(AUTH_JWT),
};

export default AuthService;
